/**
 * 권한 코드 단일 소스(Source of Truth).
 *
 * 라우팅(App.tsx), 사이드바 메뉴(Sidebar.tsx), 권한 설정 UI(EditUserPermissionsModal.tsx)
 * 등 여러 곳에 흩어져 있던 권한 코드 문자열을 한 곳으로 모은다.
 *
 * 주의: 여기의 값은 백엔드 app/core/permissions_seed.py 의 권한 코드와 반드시 일치해야 한다.
 */
export const PERMISSIONS = {
  // 페이지 접근 권한
  PAGE_DASHBOARD: 'page_dashboard_view',
  PAGE_RAW_DATA: 'page_raw_data_view',
  PAGE_LABEL_DATA: 'page_label_data_view',
  PAGE_DATASET: 'page_dataset_view',
  PAGE_TEST_DATASET: 'page_test_dataset_view',
  PAGE_TRAINING: 'page_training_view',
  PAGE_DEPLOYMENT: 'page_deployment_view',
  PAGE_USER_MANAGEMENT: 'page_user_management_view',
  PAGE_RAW_COLLECTION_REPORT: 'page_raw_collection_report_view',
  PAGE_IMAGE_EXPLORER: 'page_image_explorer_view',
  // 원천 데이터 화면 내 기능 권한 (탭)
  RAW_DATA_MANUAL_TAB: 'raw_data_manual_tab',
  RAW_DATA_AUTO_TAB: 'raw_data_auto_tab',
  // 라벨/데이터셋 구조/프로젝트 관리 권한
  LABEL_PROJECT_MANAGE: 'label_project_manage',
  DATASET_PROJECT_MANAGE: 'dataset_project_manage',
} as const

export type PermissionCode = typeof PERMISSIONS[keyof typeof PERMISSIONS]
